import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { MapStyleSelectorContainer } from "./MapStyleSelectorStyle";
import { MapStyle, setMapStyleState, useMapStyle } from "../../features/mapDisplay/mapDisplaySlice";
import { MAP_STYLE } from "../UserVisibleStrings";
import { useDispatch } from "react-redux";


const MapStateToggle: React.FC = () =>
{
    const mapStyleState = useMapStyle();
    const dispatch = useDispatch();

    const handleStyleChange = ( event: React.MouseEvent<HTMLElement>, newStyle: MapStyle ) =>
    {
        if ( newStyle !== null )
        {
            dispatch( setMapStyleState( newStyle ) );
        }
    };

    return (
        <MapStyleSelectorContainer>
            <div style = {{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                <div style = {{ display: "flex", alignItems: "center" }}>
                    <span style = {{ marginLeft: "10px", fontSize: "1.1em" }}>{MAP_STYLE}</span>
                </div>
                <ToggleButtonGroup
                    value = {mapStyleState}
                    exclusive
                    onChange = {handleStyleChange}
                    aria-label = "map style"
                    sx = {{
                        margin: "5px 5px 5px 5px",
                        width: "100%",
                    }}
                >
                    {Object.entries( MapStyle ).map( ( [ label, styleUrl ] ) => (
                        <ToggleButton
                            key = {styleUrl}
                            value = {styleUrl}
                            aria-label = {label}
                            sx = {{
                                fontSize: ".95em",
                                padding: "6px 12px",
                            }}
                        >
                            {label}
                        </ToggleButton>
                    ) )}
                </ToggleButtonGroup>
            </div>
        </MapStyleSelectorContainer>
    );
};

export default MapStateToggle;
